module.exports = __webpack_public_path__ + "static/media/1POLICY10.a0f93faf.jpg";